import { Children, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Strict single-row horizontal track with floating arrows + snap + touch drag.
// Children are flattened via Children.toArray so each item becomes its own
// horizontal cell (prevents sibling arrays from stacking vertically).
export default function SingleLineScrollTrack({ children, testid = "scroll-track", itemClass = "" }) {
  const ref = useRef(null);
  const scrollBy = (dir) => {
    const el = ref.current; if (!el) return;
    el.scrollBy({ left: dir * Math.max(280, el.clientWidth * 0.7), behavior: "smooth" });
  };
  const items = Children.toArray(children);
  return (
    <div className="relative" data-testid={testid}>
      <button onClick={() => scrollBy(-1)} data-testid={`${testid}-left`}
        className="grid place-items-center absolute left-0 sm:-left-3 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full pf-surface border-2 pf-border shadow-[2px_2px_0_0_var(--pf-border)]">
        <ChevronLeft size={18} />
      </button>
      <div ref={ref} className="flex flex-nowrap overflow-x-auto scroll-smooth snap-x snap-mandatory gap-4 no-scrollbar pb-2 px-10 sm:px-0">
        {items.map((c, i) => <div key={i} className={`snap-start shrink-0 ${itemClass}`}>{c}</div>)}
      </div>
      <button onClick={() => scrollBy(1)} data-testid={`${testid}-right`}
        className="grid place-items-center absolute right-0 sm:-right-3 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full pf-surface border-2 pf-border shadow-[2px_2px_0_0_var(--pf-border)]">
        <ChevronRight size={18} />
      </button>
    </div>
  );
}
